export const visit = (vm, at) => {
vm(require("foundations-components/lang/sk.lyaml"));
at({ "sk": { "placeholder": "z\xE1stupn\xFD objekt" } });
};